import Type4TrendsHomePage from "../page_types/Type-4-page-components/Type4TrendsHomePage";
import Type5TrendsHomePage from "../page_types/Type-5-page-components/Type5TrendsHomePage";

import { useState } from "react";

const TrendsPage = (props) => {

    const {
        setSelectedItinerary,
        highlightedItineraries,
        bookingEngine,
    } = props;

    const {
        packageTrendsPageType,
    } = bookingEngine;

    const _PageType = parseInt(packageTrendsPageType);

    const PAGI_LIMIT = 10;
    const [ totalItems, setTotalItems ] = useState(0);
    const [ pagiCurrentPage, setpagiCurrentPage ] = useState(1);

    return <div>
        {
            _PageType===4 &&
            <Type4TrendsHomePage
                setSelectedItinerary={setSelectedItinerary}
                highlightedItineraries={highlightedItineraries}
                pageTheme={bookingEngine}
                PAGI_LIMIT={PAGI_LIMIT}
                totalItems={totalItems}
                setpagiCurrentPage={setpagiCurrentPage}
                pagiCurrentPage={pagiCurrentPage}
            />
        }
        {
            _PageType===5 &&
            <Type5TrendsHomePage
                setSelectedItinerary={setSelectedItinerary}
                highlightedItineraries={highlightedItineraries}
                pageTheme={bookingEngine}
                PAGI_LIMIT={PAGI_LIMIT}
                totalItems={totalItems}
                setpagiCurrentPage={setpagiCurrentPage}
                pagiCurrentPage={pagiCurrentPage}
            />
        }
    </div>
}

export default TrendsPage;